import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open() {
    this.element.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
  }

  close() {
    this.element.classList.add('hidden')
    document.body.style.overflow = ''
  }

  closeOnBackground(event) {
    if (event.target === this.element) {
      this.close()
    }
  }
}
